'use strict';
angular
    .module('components.service.loginServiceModule', ['selectGroupCtrlModule', 'changePasswordCtrlModule',])
    .factory('loginService', [
        '$q',
        '$timeout',
        '$injector',
        '$rootScope',
        '$modal',
        'messagePublishService',
        '$sessionStorage',
        'globleParamsSet',
        function (
            $q,
            $timeout,
            $injector,
            $rootScope,
            $modal,
            messagePublishService,
            $sessionStorage,
            globleParamsSet
        ) {
            let trsHttpService = $injector.get('trsHttpService');
            // let publicToolService = $injector.get('publicToolService');
            var cacheRouter = {
                state: '',
                param: '',
            };

            /**
             * [getDefaultGroup description]初始化用户的组织
             * @return {[type]} [description]
             */
            function getDefaultGroup() {
                var deferred = $q.defer();
                queryGroups().then(function (data) {
                    if (!data.length) {
                        // 
                    } else if (data.length === 1) {
                        // var mlfCachedUser = localStorageService.get('mlfCachedUser'); // session改变
                        var mlfCachedUser = $sessionStorage.get('mlfCachedUser');
                        if (mlfCachedUser) {
                            var params = {
                                serviceid: 'mlf_extuser',
                                methodname: 'initGroupForLoginUser',
                                GroupId: data[0].GROUPID,
                                GroupPath: data[0].GROUPPATH,
                            };
                            trsHttpService
                                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                                .then(function () { });
                            mlfCachedUser.GroupId = data[0].GROUPID;
                            mlfCachedUser.GROUPPATH = data[0].GROUPPATH.split('>').slice(0, -1); // 为了保持字段一致(GROUPPATH)
                            $rootScope.userGroupId = data[0].GROUPID;
                            messagePublishService.publish('getUserGroup', mlfCachedUser);
                        } else {
                            mlfCachedUser = {};
                        }
                        // localStorageService.set('mlfCachedUser', mlfCachedUser); // session改变
                        $sessionStorage.set('mlfCachedUser', mlfCachedUser);
                        $rootScope.curUserGroup = angular.copy(mlfCachedUser);
                    } else {
                        deferred.resolve(data);
                    }
                });
                return deferred.promise;
            }

            /**
             * [queryGroups description]获取用户的所属组织
             * @return {[type]} [description]
             */
            function queryGroups() {
                var params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'queryGroups',
                };
                var deferred = $q.defer();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function (data) {
                        deferred.resolve(data);
                    },
                    function (data) {
                        deferred.reject(data);
                    }
                );
                return deferred.promise;
            }

            return {

                /**
                 * [isNeedResetPassword description] 判断是否需要重置密码
                 * @return {Boolean} [description]
                 */
                isNeedResetPassword: function () {
                    let defer = $q.defer();
                    let params = {
                        methodname: 'checkUserNeedToResetPWd',
                        serviceid: 'mlf_extuser',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (data.CODE == -1) {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    });
                    return defer.promise;
                },

                /**
                 * [forceResetPassword description] 强制用户修改密码
                 * @return {[type]} [description]
                 */
                forceResetPassword: function () {
                    let defer = $q.defer();
                    let modalInstance = $modal.open({
                        templateUrl: './components/service/loginService/changePasswordModal/changePassword_tpl.html',
                        windowClass: 'change_password_modal',
                        backdrop: false,
                        controller: 'changePasswordCtrl',
                        keyboard: false,
                        resolve: {},
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve();
                    });
                    return defer.promise;
                },
                checkLogin: function (user) {
                    var deferred = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getCheckLoginUrl(), {}, 'get').then(function (data) {
                        deferred.resolve(data);
                    });
                    return deferred.promise;
                },
                isShowCode: function () {
                    var deferred = $q.defer();
                    trsHttpService.httpServer('/wcm/check.do', {}, 'get').then(function (data) {
                        deferred.resolve(data);
                    });
                    return deferred.promise;
                },
                login: function (username, password, code) {
                    var user = {
                        UserName: username,
                        Password: password,
                        Code: code,
                    };
                    var deferred = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getLoginServiceUrl(), user, 'post').then(function (data) {
                        if (data.code === 1) {
                            deferred.resolve('success');
                        } else {
                            //
                            deferred.reject(data);
                        }
                    });
                    return deferred.promise;
                },

                /**
                 * [getCurrLoginUser description]获取当前用户信息
                 * @return {[type]} [description]
                 */
                getCurrLoginUser: function () {
                    let defer = $q.defer();
                    let userInfo = $sessionStorage.get('curUserInfo');
                    if (userInfo) {
                        defer.resolve(userInfo);
                    } else {
                        let params = {
                            serviceid: 'mlf_extuser',
                            methodname: 'getCurrUserInfo',
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                            $sessionStorage.set('curUserInfo', data);
                            defer.resolve(data);
                        });
                    }
                    return defer.promise;
                },
                setCacheRouter: function (state, param) {
                    cacheRouter.state = state.name;
                    cacheRouter.param = param;
                },
                getCacheRouter: function () {
                    return cacheRouter;
                },

                /**
                 * [selectGroup description]打开组织选择弹窗
                 * @return {[type]} [description]
                 */
                selectGroup: function () {
                    let defer = $q.defer();
                    let hasLogin = globleParamsSet.whetherLogin();
                    if (hasLogin) {
                        defer.reject();
                        return defer.promise;
                    }
                    let mlfCachedUser = $sessionStorage.get('mlfCachedUser');
                    getDefaultGroup().then(function (groups) {
                        mlfCachedUser.GroupId = groups[0].GROUPID;
                        $rootScope.userGroupId = groups[0].GROUPID;
                        $sessionStorage.set('mlfCachedUser', mlfCachedUser);
                        $rootScope.curUserGroup = angular.copy(mlfCachedUser);
                        var modalInstance = $modal.open({
                            templateUrl: './components/service/loginService/selectGroupModal/selectGroup_tpl.html',
                            windowClass: 'login-group-modal',
                            backdrop: false,
                            controller: 'loginInitGroupCtrl',
                            keyboard: false,
                            resolve: {
                                groups: function () {
                                    return groups;
                                },
                            },
                        });
                        modalInstance.result.then(function (result) {
                            var params = {
                                serviceid: 'mlf_extuser',
                                methodname: 'initGroupForLoginUser',
                                GroupId: result.GROUPID,
                                GroupPath: angular.isArray(result.GROUPPATH)
                                    ? result.GROUPPATH.join('>')
                                    : result.GROUPPATH,
                            };
                            trsHttpService
                                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                                .then(function (data) {
                                    mlfCachedUser.GroupId = result.GROUPID;
                                    $rootScope.userGroupId = result.GROUPID;
                                    $sessionStorage.set('mlfCachedUser', mlfCachedUser);
                                    $timeout(function () {
                                        $rootScope.curUserGroup = angular.copy(mlfCachedUser);
                                    });
                                });
                        });
                    });
                    // return defer.promise;
                },
            };
        },
    ]);
